const limitString = (string, limit) => string.substring(0, limit)
export default limitString
